export default __webpack_public_path__ + "static/media/noData.4c0c6a31.png";